module.exports = __webpack_public_path__ + "img/card-serviceplaces.03dbb8ef.svg";